import { render } from "./supplierSpecificView.vue?vue&type=template&id=98b5c8e4"
import script from "./supplierSpecificView.vue?vue&type=script&lang=js"
export * from "./supplierSpecificView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__